import { Controller } from "@hotwired/stimulus"

const HIGHLIGHT_KEY = "listing-card-highlight"

export default class extends Controller {
  connect() {
    const listingId = sessionStorage.getItem(HIGHLIGHT_KEY)
    if (listingId) {
      sessionStorage.removeItem(HIGHLIGHT_KEY)
      requestAnimationFrame(() => this.#highlightCard(listingId))
    }
  }

  captureCard(event) {
    const link = event.target.closest(".ListingGrid a[data-listing-id]")
    if (!link) return
    sessionStorage.setItem(HIGHLIGHT_KEY, link.dataset.listingId)
  }

  #highlightCard(listingId) {
    this.element.querySelectorAll(".ListingGrid .animate-halo").forEach(el => el.classList.remove("animate-halo"))
    const link = this.element.querySelector(`.ListingGrid a[data-listing-id="${listingId}"]`)
    link?.classList.add("animate-halo")
  }
}
